var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'simpleflex-column': true, ... _vm.classes},style:({ background: _vm.backgroundImg? 'url(' + _vm.backgroundImg + ')' : null, objectFit: 'cover' })},[_c('div',{staticClass:"column-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }